<app-spu-form-wrapper
  data-testid="package-spu-view-form-wrapper"
  [config]="config"
  [editMode]="false"
  [viewMode]="true"
  [showFaq]="true"
></app-spu-form-wrapper>
